module.exports = __webpack_public_path__ + "static/media/moodboardRated.c2f5712e.png";